'use strict';

var React = require('react');

var SvgCashPoundMajor = function SvgCashPoundMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 6a1.75 1.75 0 0 0-1.75 1.75v1.5h-.75a.75.75 0 0 0 0 1.5h.75v1h-.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-2.25v-1h.75a.75.75 0 0 0 0-1.5h-.75v-1.5a.25.25 0 0 1 .25-.25h.75v.5a.75.75 0 0 0 1.5 0v-.75c0-.69-.56-1.25-1.25-1.25h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-5.5 7a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z"
  }));
};
SvgCashPoundMajor.displayName = "CashPoundMajor";

exports.SvgCashPoundMajor = SvgCashPoundMajor;
